module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "flow-measurement"
  }, [(_vm.flowMeasurementMethodDialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "flow-measurement-method-dialog"
    },
    model: {
      value: (_vm.flowMeasurementMethodDialog),
      callback: function($$v) {
        _vm.flowMeasurementMethodDialog = $$v
      },
      expression: "flowMeasurementMethodDialog"
    }
  }, [_c('v-card', [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('v-card-title', {
    staticClass: "flow-measurement-method-dialog-title text-break justify-center mb-2 text-center px-0",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("\n            Método de medición de caudal\n          ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2 text-end",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.flowMeasurementMethodDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#00202F"
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n          Para realizar la medición de caudal, se utilizó un caudalímetro ultrasónico. Este dispositivo mide el flujo de líquidos o gases\n          en tuberías o conductos mediante ondas ultrasónicas, determinando así la velocidad del fluido y calculando el caudal\n          volumétrico.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          Una de sus principales ventajas es su portabilidad y facilidad de instalación, lo que permite operar sin alterar los\n          componentes del sistema a medir. Esto garantiza una medición confiable desde el momento de su instalación.\n        ")]), _vm._v(" "), _c('v-img', {
    staticClass: "mt-5",
    attrs: {
      "src": require('../../assets/audits/flowMeasurementMethod.png'),
      "max-width": "315px"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.commentsDialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "comments-dialog"
    },
    model: {
      value: (_vm.commentsDialog),
      callback: function($$v) {
        _vm.commentsDialog = $$v
      },
      expression: "commentsDialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "py-3"
  }, [_vm._v("\n          " + _vm._s(_vm.comments) + "\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.imagesDialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "comments-dialog"
    },
    model: {
      value: (_vm.imagesDialog),
      callback: function($$v) {
        _vm.imagesDialog = $$v
      },
      expression: "imagesDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "black"
    }
  }, [_c('v-carousel', {
    ref: "flow-measurement-carousel",
    staticClass: "flow-measurement-carousel",
    staticStyle: {
      "align-content": "center",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "continuous": false,
      "hide-delimiters": "",
      "height": "400px"
    },
    model: {
      value: (_vm.carouselModel),
      callback: function($$v) {
        _vm.carouselModel = $$v
      },
      expression: "carouselModel"
    }
  }, _vm._l((_vm.images), function(image, imageIndex) {
    return _c('v-carousel-item', {
      key: imageIndex,
      staticStyle: {
        "align-content": "center",
        "align-items": "center",
        "justify-content": "center"
      }
    }, [_c('v-img', {
      staticClass: "d-flex align-center justify-center",
      attrs: {
        "src": image.file.url,
        "max-width": "100%",
        "max-height": "100%",
        "contain": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gradient-layer"
    }, [_c('p', {
      staticClass: "gradient-layer-text"
    }, [_vm._v(_vm._s(image.label || ''))])])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', [_c('p', {
    staticClass: "flow-measurement-title mb-0"
  }, [_vm._v("Detalle de medición de caudal")]), _vm._v(" "), _c('a', {
    staticClass: "flow-measurement-subtitle mb-0",
    on: {
      "click": function($event) {
        _vm.flowMeasurementMethodDialog = true
      }
    }
  }, [_vm._v("Método de medición")])]), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "align-content": "center"
    },
    attrs: {
      "align": "end"
    }
  }, [_c('v-icon', {
    staticClass: "d-inline icon-center",
    attrs: {
      "color": "#00202F",
      "size": "1rem"
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 d-inline"
  }, [_vm._v(_vm._s(_vm.parseDate(_vm.flowMeasurementData.workDate)))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-container', {
    staticClass: "Content d-flex pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "Options overflow-hidden pr-1 mr-3"
  }, [_c('v-radio-group', {
    staticClass: "px-4 pt-0",
    attrs: {
      "mandatory": ""
    },
    model: {
      value: (_vm.selectedOption),
      callback: function($$v) {
        _vm.selectedOption = $$v
      },
      expression: "selectedOption"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('v-radio', {
      key: option,
      style: ({
        'font-weight': _vm.selectedOption === option ? '600' : '400'
      }),
      attrs: {
        "label": option,
        "value": option,
        "color": "#0098E1"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Graphic fill-height align-center justify-left"
  }, [(_vm.selectedOption === 'Recomendaciones') ? [(_vm.checkObservationsDocumentEmpty()) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "place-content": "center"
    }
  }, [_c('p', {
    staticClass: "text-center mb-0"
  }, [_vm._v("No hay recomendaciones")])]) : _c('KeystoneDocumentRenderer', {
    attrs: {
      "document": _vm.flowMeasurementData.observations.document
    }
  })] : _vm._e(), _vm._v(" "), (_vm.selectedOption === 'Resultados') ? [(_vm.flowMeasurementData.flowSamples.length === 0) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "place-content": "center"
    }
  }, [_c('p', {
    staticClass: "text-center mb-0"
  }, [_vm._v("No hay mediciones")])]) : _vm._l((_vm.sortedFlowSamples), function(sample, sampleIndex) {
    return _c('v-row', {
      key: sampleIndex,
      staticClass: "mt-3"
    }, [_c('v-col', [_c('v-row', [_c('p', {
      staticClass: "mb-0 ml-2",
      staticStyle: {
        "font-size": "1.13rem",
        "font-weight": "600"
      }
    }, [_vm._v("Medición " + _vm._s(sampleIndex + 1))]), _vm._v(" "), (_vm.getFlowSamplesImages([sample], sampleIndex).length > 0) ? _c('v-icon', {
      staticClass: "ml-4",
      attrs: {
        "size": "1.38rem",
        "color": "#0099E1"
      },
      on: {
        "click": function($event) {
          _vm.openImagesDialog(_vm.getFlowSamplesImages([sample], sampleIndex))
        }
      }
    }, [_vm._v("mdi-camera-outline")]) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Hora de medición")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Caudal medido (m3/h)")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Q")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("S")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Vel (m/s)")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Presión de trabajo (PSI)")])])], 1), _vm._v(" "), _c('v-row', {
      staticClass: "mt-1"
    }, [_c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(_vm.formatMeasureTime(sample.measureDate)))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(sample.flow !== undefined ? _vm.formatNumber(sample.flow, 2) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(sample.q !== undefined ? sample.q : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(sample.s !== undefined ? sample.s : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(sample.vel !== undefined ? _vm.formatNumber(sample.vel, 3) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(sample.eqPressure !== undefined ? _vm.formatNumber(sample.eqPressure, 2) : '-'))])])], 1)], 1)], 1)
  })] : _vm._e(), _vm._v(" "), (_vm.selectedOption === 'Estado al momento de la medición') ? [_c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', [_c('v-row', [_c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Estado del equipo")]), _vm._v(" "), (_vm.flowMeasurementData.device && _vm.flowMeasurementData.device.locationLatitude && _vm.flowMeasurementData.device.locationLongitude) ? _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "1.38rem",
      "color": "#0099E1"
    },
    on: {
      "click": function($event) {
        return _vm.goToLocation({
          latitude: _vm.flowMeasurementData.device.locationLatitude,
          longitude: _vm.flowMeasurementData.device.locationLongitude
        })
      }
    }
  }, [_vm._v("mdi-map-marker")]) : _vm._e(), _vm._v(" "), (_vm.getEqStatusImages(_vm.flowMeasurementData.eqStatus).length > 0) ? _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "1.38rem",
      "color": "#0099E1"
    },
    on: {
      "click": function($event) {
        _vm.openImagesDialog(_vm.getEqStatusImages(_vm.flowMeasurementData.eqStatus))
      }
    }
  }, [_vm._v("mdi-camera-outline")]) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Movimiento del equipo")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Velocidad")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Presión")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Comentarios")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.flowMeasurementData.eqStatus && _vm.flowMeasurementData.eqStatus.eqStatusValue && _vm.flowMeasurementData.eqStatus.eqStatusValue.name || '-'))])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.flowMeasurementData.eqStatus && _vm.flowMeasurementData.eqStatus.speed ? _vm.formatNumber(parseFloat(_vm.flowMeasurementData.eqStatus.speed) * 100, 2) : '-') + "%")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.flowMeasurementData.eqStatus && _vm.flowMeasurementData.eqStatus.pressure ? _vm.formatNumber(_vm.flowMeasurementData.eqStatus.pressure, 2) : '-') + " PSI")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.flowMeasurementData.eqStatus && _vm.flowMeasurementData.eqStatus.observations ? _vm.flowMeasurementData.eqStatus.observations : '-'))])])], 1), _vm._v(" "), (_vm.flowMeasurementData.pumps && _vm.flowMeasurementData.pumps.length > 0) ? [_c('v-row', [_c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Estado de la bomba")]), _vm._v(" "), (_vm.somePumpHasCoordinates(_vm.flowMeasurementData.pumps)) ? _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "1.38rem",
      "color": "#0099E1"
    },
    on: {
      "click": function($event) {
        _vm.goToLocation(_vm.getPumpCoordinates(_vm.flowMeasurementData.pumps))
      }
    }
  }, [_vm._v("mdi-map-marker")]) : _vm._e(), _vm._v(" "), (_vm.getPumpsImages(_vm.flowMeasurementData.pumps).length > 0) ? _c('v-icon', {
    staticClass: "ml-4",
    attrs: {
      "size": "1.38rem",
      "color": "#0099E1"
    },
    on: {
      "click": function($event) {
        _vm.openImagesDialog(_vm.getPumpsImages(_vm.flowMeasurementData.pumps))
      }
    }
  }, [_vm._v("mdi-camera-outline")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.flowMeasurementData.pumps), function(pump, pumpIndex) {
    return [(pumpIndex === 0) ? _c('v-row', [_c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Tipo de bomba")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("RPM")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Presión de pozo")])]), _vm._v(" "), (pump.pipe && pump.pipe.diameter) ? _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Cañería")])]) : _vm._e(), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Distancia a equipo")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Comentarios")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
      staticClass: "mt-1"
    }, [_c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(pump.type && pump.type.name || '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(pump.pumpStatus && _vm.formatNumber(pump.pumpStatus.rpm, 2) || '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(pump.pumpStatus && pump.pumpStatus.pumpPressure ? _vm.formatNumber(pump.pumpStatus.pumpPressure, 2) : '-') + " PSI")])]), _vm._v(" "), (pump.pipe && pump.pipe.diameter) ? _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(pump.pipe.diameter))])]) : _vm._e(), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(pump.pumpStatus && _vm.formatNumber(pump.pumpStatus.deviceDistance, 1) || '-') + " m")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "3"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(pump.observations || pump.pumpStatus.description ? ((pump.observations) + " " + (pump.observations ? ("- " + (pump.pumpStatus.description)) : pump.pumpStatus.description)) : '-'))])])], 1)]
  })] : _vm._e()], 2)], 1)] : _vm._e()], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5deedc38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/FlowMeasurement.vue
// module id = 1719
// module chunks = 0